import { publicApi } from "./api";

export async function signIn({email, password}: { email: string, password: string }) {
  return publicApi.post('/auth/login', { email, password });
}